<template>
  <van-nav-bar
    :left-arrow="isLeft"
    :left-text="leftText"
    fixed
    @click-left="onClickLeft"
    class="app-header"
  >
    <div v-if="$scopedSlots.left" slot="left"><slot name="left" /></div>
    <div v-if="$scopedSlots.title" slot="title"><slot name="title" /></div>
    <div v-if="$scopedSlots.right" slot="right"><slot name="right" /></div>
  </van-nav-bar>
</template>

<script>
export default {
  name: 'AppHeader',
  props: ['isLeft', 'leftText'],
  methods: {
    onClickLeft() {
      this.$emit('click-left');
    }
  }
}
</script>
<style lang="less" scoped>
.app-header.van-nav-bar {
  .fixedapp();
  .van-nav-bar__left {
    .flex-center-v();
    height:100%;
  }
}
</style>